export const REQUEST_LOCATIONS = 'REQUEST_LOCATIONS';
export const RECEIVE_LOCATIONS = 'RECEIVE_LOCATIONS';

export const REQUEST_PARTNERS = 'REQUEST_PARTNERS';
export const RECEIVE_PARTNERS = 'RECEIVE_PARTNERS';

export const REQUEST_FEATURED_LOCATIONS = 'REQUEST_FEATURED_LOCATIONS';
export const RECEIVE_FEATURED_LOCATIONS = 'RECEIVE_FEATURED_LOCATIONS';



// WEBPACK FOOTER //
// ./src/actions/constants.js